import { NumericFormat } from "react-number-format";

const FormattedInput = ({
  formatType = "number", // number | currency
  value,
  onChange,
  ...props
}) => {
  return (
    <NumericFormat
      {...props}
      value={value}
      thousandSeparator="."
      decimalSeparator=","
      allowNegative={false}
      decimalScale={formatType === "currency" ? 2 : undefined}
      fixedDecimalScale={formatType === "currency"}
      prefix={formatType === "currency" ? "€ " : ""}
      //   onValueChange={(values) => {
      //     onChange(values.value);
      //   }}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
    />
  );
};

export default FormattedInput;
